import { useEffect } from 'react';
import { useWorkspace } from '@/contexts/WorkspaceContext';

export const useBrand = () => {
  const { brand, currentWorkspace } = useWorkspace();

  useEffect(() => {
    const root = document.documentElement;

    if (brand?.primary) {
      root.style.setProperty('--primary', brand.primary);
    }

    if (brand?.accent) {
      root.style.setProperty('--accent', brand.accent);
    }

    if (brand?.favicon_url) {
      let favicon = document.querySelector('link[rel="icon"]') as HTMLLinkElement;

      if (!favicon) {
        favicon = document.createElement('link');
        favicon.rel = 'icon';
        document.head.appendChild(favicon);
      }

      favicon.href = brand.favicon_url;
    }

    document.title = currentWorkspace?.name
      ? `${currentWorkspace.name} – BillPortal`
      : 'BillPortal';
  }, [brand, currentWorkspace]);

  return brand;
};